import React, { useCallback } from "react";
import { createPortal } from "react-dom";
import { WholePageOverlay, Trap } from "../styles";
// Import these individually, otherwise all hooks will be included in the bundle
import { useEventListener } from "../../../../hooks/useEventListener";
import { useTrapFocus } from "../../../../hooks/useTrapFocus";
import { useScrollLock } from "../../../../hooks/useScrollLock";
export var MODAL_ID = "modal";
export var BaseModal = function (_a) {
    var closeOnClickOutside = _a.closeOnClickOutside, showModal = _a.showModal, closeModal = _a.closeModal, _b = _a.align, align = _b === void 0 ? "center" : _b, children = _a.children;
    var trapRef = useTrapFocus({
        includeContainer: true,
        returnFocus: true,
        updateNodes: true,
        isActive: showModal,
    });
    var handleOverlayClick = useCallback(function (e) {
        if (e.target === trapRef.current && closeOnClickOutside) {
            closeModal();
        }
    }, [closeModal, closeOnClickOutside]);
    useEventListener({
        type: "keydown",
        listener: function (e) {
            if (e.key === "Escape") {
                closeModal();
            }
        },
    });
    useScrollLock({ showModal: showModal });
    return showModal
        ? createPortal(React.createElement(WholePageOverlay, { align: align, isVisible: showModal, onClick: handleOverlayClick, "aria-hidden": !showModal },
            React.createElement(Trap, { ref: trapRef, align: align }, children)), document.querySelector("body"))
        : null;
};
